import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    backgroundImage: {
      backgroundImage: "url(/images/login_background_c.jpg)",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundPosition: "center"
    },
    signup_backgroundImage: {
      backgroundImage: `linear-gradient(${theme.palette.blue.main}AA, ${theme.palette.blue.main}AA), url(/images/signup_background.jpg)`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundPosition: "center center",
      backgroundAttachment: "fixed",
      backgroundColor: theme.palette.blue.main
    },
    demoSignupLayout: {
      transition:
        "width 450ms cubic-bezier(0.4, 0, 0.2, 1), max-height 450ms cubic-bezier(0.4, 0, 0.2, 1), height 450ms cubic-bezier(0.4, 0, 0.2, 1)",
      willChange: "width, max-height, height",
      // Hide the inner scrollbar visually while still allowing scroll if
      // content exceeds maxHeight. Cleaner look on the schedule step where
      // the calendar fills the dialog.
      scrollbarWidth: "none",
      "-ms-overflow-style": "none",
      "&::-webkit-scrollbar": {
        display: "none",
        width: 0,
        height: 0
      }
    }
  };
});
